import { AfterViewInit, Component, ElementRef, forwardRef, Input, ViewChild } from '@angular/core';
import { DestroyableComponent } from '../../../utils/destroyable.component';
import { fromEvent, Observable, pipe } from 'rxjs';
import { startWith, map, delay } from 'rxjs/operators';
import { STATES } from '../../../../constants';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-state-control',
  templateUrl: './state-control.component.html',
  styleUrls: ['./state-control.component.scss'],
  providers: [
    { 
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StateControlComponent),
      multi: true
    }
  ]
})
export class StateControlComponent extends DestroyableComponent implements ControlValueAccessor, AfterViewInit {
  @ViewChild('control') control: ElementRef; 

  private _stateValue = 0;
  
  get stateValue() {
    return this._stateValue;
  }
  
  @Input()
  set stateValue(val) {
    this._stateValue = val;
    this.propagateChange(this._stateValue);
  }

  propagateChange: (value: number) => void = () => {};

  state: string;
  states = STATES.map((state) => state.abbreviation);
  stateOriginOptions$: Observable<string[]>;

  filterStateOptionsOperator = pipe(
    startWith(""),
    delay(0),
    map((value: string) => this.filterOptions(value, this.states))
  );

  private filterOptions(value: string, options: string[]): string[] {
    const filterValue = value.toLowerCase();
    return options.filter(
      (option) => option.toLowerCase().indexOf(filterValue) === 0
    );
  }

  writeValue(value: number | undefined) {
    if (value !== undefined) {
      this._stateValue = value;
    }
  }

  registerOnChange(fn: (value: number) => void): void {
    this.propagateChange = fn;
  }

  registerOnTouched(): void {
  }

  ngAfterViewInit() {
    this.stateOriginOptions$ = fromEvent(this.control.nativeElement, 'keyup').pipe(
      map((res: KeyboardEvent) => (res.target as HTMLInputElement).value),
      this.filterStateOptionsOperator
    );
  }
}
